import { NgModule } from '@angular/core';
import { LibFactFindComponent } from './lib-fact-find-icon.component';

@NgModule({
  declarations: [LibFactFindComponent],
  imports: [],
  exports: [LibFactFindComponent],
})
export class LibFactFindIconModule {}
